import React from 'react';

const ArrowRight = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.99913 13.0001L14.5891 13.0001L11.2891 16.2901C11.1008 16.4784 10.995 16.7338 10.995 17.0001C10.995 17.2664 11.1008 17.5218 11.2891 17.7101C11.4774 17.8984 11.7328 18.0041 11.9991 18.0041C12.2654 18.0041 12.5208 17.8984 12.7091 17.7101L17.7091 12.7101C17.8002 12.615 17.8715 12.5028 17.9191 12.3801C18.0191 12.1366 18.0191 11.8635 17.9191 11.6201C17.8715 11.4973 17.8002 11.3852 17.7091 11.2901L12.7091 6.29006C12.6162 6.19633 12.5056 6.12194 12.3837 6.07117C12.2618 6.0204 12.1311 5.99426 11.9991 5.99426C11.8671 5.99426 11.7364 6.0204 11.6146 6.07117C11.4927 6.12194 11.3821 6.19633 11.2891 6.29006C11.1954 6.38302 11.121 6.49362 11.0702 6.61548C11.0195 6.73734 10.9933 6.86805 10.9933 7.00006C10.9933 7.13207 11.0195 7.26278 11.0702 7.38464C11.121 7.50649 11.1954 7.61709 11.2891 7.71006L14.5891 11.0001L6.99913 11.0001C6.73391 11.0001 6.47956 11.1054 6.29202 11.293C6.10448 11.4805 5.99913 11.7348 5.99913 12.0001C5.99913 12.2653 6.10448 12.5196 6.29202 12.7072C6.47956 12.8947 6.73391 13.0001 6.99913 13.0001Z"
      fill="CurrentColor"
    />
  </svg>
);

export default ArrowRight;
